import _Object$create from "@babel/runtime-corejs2/core-js/object/create";
import setPrototypeOf from "./setPrototypeOf.js";
export default function _inheritsLoose(subClass, superClass) {
  subClass.prototype = _Object$create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/helpers/esm/inheritsLoose.js
// module id = 2
// module chunks = 33